module.exports = __webpack_public_path__ + "static/media/iconPDF.8ff84e35.png";